(() => {
  const menus = document.querySelectorAll('[data-mobile-menu]');

  menus.forEach((menu) => {
    const closeButton = menu.querySelector('[data-mobile-menu-close]');
    const links = menu.querySelectorAll('a');

    const closeMenu = () => {
      menu.removeAttribute('open');
      document.body.classList.remove('sc-menu-open');
      menu.querySelector('summary')?.focus();
    };

    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('sc-menu-open', menu.open);
    });

    closeButton?.addEventListener('click', closeMenu);
    links.forEach((link) => link.addEventListener('click', () => {
      document.body.classList.remove('sc-menu-open');
    }));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) closeMenu();
    });
  });
})();

(() => {
  const loader = document.querySelector('[data-page-loader]');

  if (!loader || window.Shopify?.designMode) return;

  const showLoader = () => {
    loader.hidden = false;
    loader.setAttribute('aria-hidden', 'false');
    loader.classList.add('is-active');
  };

  const hideLoader = () => {
    loader.classList.remove('is-active');
    loader.setAttribute('aria-hidden', 'true');
    loader.hidden = true;
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const source = event.target instanceof Element ? event.target : null;
    const link = source?.closest('a[href]');

    if (!link || link.hasAttribute('download')) return;
    if (link.target && link.target !== '_self') return;
    if (link.dataset.noPageLoader !== undefined) return;

    const destination = new URL(link.href, window.location.href);
    const current = new URL(window.location.href);

    if (destination.origin !== current.origin) return;
    if (!['http:', 'https:'].includes(destination.protocol)) return;

    const samePage =
      destination.pathname === current.pathname &&
      destination.search === current.search;

    if (samePage && destination.hash) return;

    showLoader();
  }, { capture: true });

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;

    if (!form || form.target === '_blank') return;
    showLoader();
  }, { capture: true });

  window.addEventListener('pageshow', hideLoader);
})();
